import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegTermsConditionsComponent } from './terms-conditions.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@xref/ngx';

@NgModule({
    declarations: [RegTermsConditionsComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TranslateModule
    ],
    exports: [RegTermsConditionsComponent],
    providers: [],
})
export class RegTermsConditionsModule {}
